var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const GET_SET_COMPANIES = 'api/company';
const GET_SET_BILLING = 'api/billing';
export const applyCatalogConsolidation = function (companyId, data) {
    return __awaiter(this, void 0, void 0, function* () {
        const config = {
            headers: { Authorization: `Bearer ${this.apiToken}` }
        };
        return this.axiosInstance.post(`${GET_SET_COMPANIES}/${companyId}/catalog-consolidation/apply`, data, config);
    });
};
export const previewCatalogConsolidation = function (companyId, data) {
    return __awaiter(this, void 0, void 0, function* () {
        const config = {
            headers: { Authorization: `Bearer ${this.apiToken}` }
        };
        return this.axiosInstance.post(`${GET_SET_COMPANIES}/${companyId}/catalog-consolidation/preview`, data, config);
    });
};
export const updateCompanyTaxInfoCertificates = function (companyId, data) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}`, 'Content-Type': false }
            };
            const response = yield this.axiosInstance.post(`${GET_SET_COMPANIES}/${companyId}/taxInfo/certificates`, data, config);
            return response;
        }
        catch (error) {
            console.error('Error fetching updateCompanyTaxInfoById:', error);
            throw error;
        }
    });
};
export const updateCFDIOrgLogo = function (companyId, data) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}`, 'Content-Type': false }
            };
            const response = yield this.axiosInstance.post(`${GET_SET_COMPANIES}/${companyId}/taxInfo/logo`, data, config);
            return response;
        }
        catch (error) {
            console.error('Error fetching updateCFDIOrgLogo:', error);
            throw error;
        }
    });
};
export const enableBillingOverage = function (data) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            const response = yield this.axiosInstance.post(`${GET_SET_BILLING}/overage/enable`, data, config);
            return response;
        }
        catch (error) {
            console.error('Error fetching enableBillingOverage:', error);
            throw error;
        }
    });
};
export const disableBillingOverage = function (data) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            const response = yield this.axiosInstance.post(`${GET_SET_BILLING}/overage/disable`, data, config);
            return response;
        }
        catch (error) {
            console.error('Error fetching disableBillingOverage:', error);
            throw error;
        }
    });
};
export const enableCFDIAddon = function (data) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            const response = yield this.axiosInstance.post(`${GET_SET_BILLING}/cfdi/enable`, data, config);
            return response;
        }
        catch (error) {
            console.error('Error fetching enableCFDIAddon:', error);
            throw error;
        }
    });
};
export const disableCFDIAddon = function (data) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            const response = yield this.axiosInstance.post(`${GET_SET_BILLING}/cfdi/disable`, data, config);
            return response;
        }
        catch (error) {
            console.error('Error fetching disableCFDIAddon:', error);
            throw error;
        }
    });
};
export const previewSubscriptionPlanChange = function (data) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            const response = yield this.axiosInstance.post(`${GET_SET_BILLING}/subscription/change-plan/preview`, data, config);
            return response;
        }
        catch (error) {
            console.error('Error fetching previewSubscriptionPlanChange:', error);
            throw error;
        }
    });
};
export const changeSubscriptionPlan = function (data) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            const response = yield this.axiosInstance.post(`${GET_SET_BILLING}/subscription/change-plan`, data, config);
            return response;
        }
        catch (error) {
            console.error('Error fetching changeSubscriptionPlan:', error);
            throw error;
        }
    });
};
